import {styled} from '@innowise-group/ui-kit';

export const ModalTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
`;
